import React, { useEffect, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import type { RcFile, UploadProps } from 'antd/es/upload';
import type { UploadFile } from 'antd/es/upload/interface';
import axios from 'axios';
import { FormInstance } from 'antd/es/form/Form';
import { log } from 'console';

interface IProps {
  form: FormInstance;
  field: string;
  files: string[];
  onChangeState: any;
}

const UploadImages: React.FC<IProps> = (props) => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  useEffect(() => {
    if (props.files) {
      const list: UploadFile[] = props.files.map((image, index) => {
        return {
          uid: index.toString(),
          name: image,
          status: 'done',
          url: image,
        } as UploadFile;
      });
      setFileList(list);
    }
  }, [props.files]);

  const handleChange: UploadProps['onChange'] = ({
    fileList: newFileList,
    file: fileImages,
  }) => {
    let dataImage = props.form.getFieldValue('services')[props.field];
    if (fileImages?.status === 'removed') {
      let url = newFileList
        .map((item) => item.url)
        .filter((notUndefined) => notUndefined !== undefined);
      dataImage = url.filter((x) => dataImage.includes(x));
      
        props.form.setFieldsValue({
          services: {
            ...props.form.getFieldValue('services'),
            [props.field]: dataImage,
          },
        });

        props.onChangeState({
          ...props.form.getFieldValue('services'),
          [props.field]: dataImage,
        });
    }

    const list: UploadFile[] = dataImage.map((image:any, index:any) => {
      return {
        uid: index.toString(),
        name: image,
        status: 'done',
        url: image,
      } as UploadFile;
    });
    setFileList(list);
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <>
      <Upload
        listType="picture-card"
        fileList={fileList}
        onChange={handleChange}
        beforeUpload={async (file: any) => {
          const data = new FormData();
          data.append('folderType', 'ApplyJobs');
          data.append('images[]', file);
          const config = {
            headers: { 'content-type': 'multipart/form-data' },
          };
          const res = await axios.post<any>(
            `/uploads/upload-image`,
            data,
            config
          );
          const url: string = res.data[0];
          props.form.setFieldsValue({
            services: {
              ...props.form.getFieldValue('services'),
              [props.field]: [...props.files, url],
            },
          });
          props.onChangeState({
            ...props.form.getFieldValue('services'),
            [props.field]: [...props.files, url],
          });
          return false;
        }}
      >
        {fileList.length >= 8 ? null : uploadButton}
      </Upload>
    </>
  );
};

export default UploadImages;
